import { FeaturedBlogS } from '@/components/blog';
import { AboutSection, DubaiBanner, HowWeWork, InteriorServices, SnapShotProjects, WhatSetsApart, WhyPartnerWithUs } from '@/components/dubai/homePage';
import { DecoratorProfiles, Happyclient, Liveprojects } from '@/components/interiors';
import { AeHomeLongBody } from '@/components/longBody/homeLongBody/AeHomeLongBody';
import { GoogleReviews } from '@/components/shared/googleReviews';
import { MetaHead } from '@/components/shared/metaHead';
import { IBlogPost, IMetaHead, IvrProducts } from '@/interfaces';
import { IContactUs } from '@/interfaces/IContactUs';
import { IDesignCityHappyClientSub, IDesignData } from '@/interfaces/IDesignCity';
import { ICityWiseProfile } from '@/interfaces/IPortfolio';
import { IReviews } from '@/interfaces/IReviews';
import { CountryCode } from '@/lib/constants';
import blogService from '@/lib/services/blogService';
import masterService from '@/lib/services/masterService';
import productService from '@/lib/services/productService';
import reviewService from '@/lib/services/reviewService';
import { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react'

const OurBrandPartners = dynamic(() => import('@/components/home/OurBrandPartners').then(mod => mod.OurBrandPartners), {
    ssr: false
});
type props = {
    designersData: ICityWiseProfile[]
    reviewsdata: IReviews[]
    happyClientsData: IDesignCityHappyClientSub[]
    latestPosts: IBlogPost[]
    valuesCitys: IDesignData
    mapdata: IContactUs
    dubaiVrProjects: IvrProducts

}
const DubaiPage: NextPage<props> = ({ designersData, reviewsdata, happyClientsData, latestPosts, valuesCitys, mapdata, dubaiVrProjects }) => {

    const metaData: IMetaHead = {
        title: "Interior Design Company in Dubai | Best Interior Designers and Decorators",
        description: "Interior Company is one of the best interior design companies in Dubai offers You commercial & residential interior services from Our top-notch designers and decorators.",
        ogImage: `${process.env.SITE_URL}/assets/images/dubai-banner-web.png`
    };
    return (
        <>
            <MetaHead metaData={metaData} />
            <DubaiBanner />
            <AboutSection aboutData={valuesCitys.summaryData} />
            <InteriorServices />
            <WhyPartnerWithUs />
            <SnapShotProjects dubaiVrProjects={dubaiVrProjects} />
            <HowWeWork />
            <DecoratorProfiles cityName={'Dubai'} profilesData={designersData} />
            <GoogleReviews reviewsdata={reviewsdata} />
            <WhatSetsApart />
            <Happyclient cityName={'Dubai'} GetHappyClientCity={happyClientsData} />
            <FeaturedBlogS countryCode={CountryCode.INR} latestPosts={latestPosts} h2Text={"Featured Blogs"} pText={"Your personal aesthetic coupled with our visual inspiration is a mood board made in heaven!"} />
            <OurBrandPartners countryCode={CountryCode.AED} />
            <Liveprojects cityName={'Dubai'} urlCity={'dubai'} objectCity={valuesCitys.cityData} Mapdata={mapdata} />
            <AeHomeLongBody />
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const designersData = await productService.getCityWiseProfiles(CountryCode.AED, 'dubai');
    const reviewsdata = await reviewService.getGoogleReview(CountryCode.AED);
    const happyClientsData = await blogService.GetHappyClientCity(CountryCode.AED, 'dubai');
    const latestPosts = await blogService.featuredPostsByCountry(CountryCode.INR);
    const valuesCitys = await productService.getDesignNumber(CountryCode.AED, 'dubai');
    const officeAddress = await masterService.getmaster(CountryCode.AED, "office_address");
    const mapdata = officeAddress.office_address.find((a: { Name: string; }) => a.Name.split(" ").join("-").toLowerCase() == 'dubai');
    const vrProducts = await productService.get3DProduct(CountryCode.AED);
    const dubaiVrProjects = vrProducts.find((d: any) => d.city == 'Dubai');


    return {
        props: { designersData, reviewsdata, happyClientsData, latestPosts, valuesCitys, mapdata, dubaiVrProjects }
    }
}

export default DubaiPage;